import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';

import { DateTimePicker } from '@mui/x-date-pickers';
import { InputAdornment } from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';
import {
  Pagination,
  Stack,
  TextField,
  CircularProgress,
  Button,
} from '@mui/material';

import { columns as Columns } from './constants/table_columns_data';
import { formatDateWithTimeZoneForSearch } from '../../../utils/dateFormats';
import FullLayout from '../../../layouts/fullLayout';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment';

import services from './service';
import { useDebounce } from 'use-debounce';
import { useBoundStore } from '../../../stores';
import { theme } from '../../../theme/theme';
import DataGrid from '../../../components/Datagrid/Datagrid';
import Number from '../../../components/CustomNumber/Number';
import DraggedIcon from '../../../assets/images/draged-Icon.png';
import TPieChart from '../VoyageReports/components/TPieChart';

const oneDayInMillis = 24 * 60 * 60 * 1000;
const initialValue = {
  t0: new Date(new Date().getTime() - oneDayInMillis).getTime(),
  t1: Date.now(),
};
function CardEvents() {
  const textPool = useBoundStore((state) => state.textPool);
  const location = useLocation();
  const [sortModel, setSortModel] = useState([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [cardEvents, setCardEvents] = useState([]);
  const [count, setCount] = useState(0);
  const [allCardEvents, setAllCardEvents] = useState([]);
  const [allCardEventsForExcel, setAllCardEventsForExcel] = useState([]);
  const [filterDataInput, setFilterDataInput] = useState('');
  const [formDateData, setFormDateData] = useState(initialValue);
  const [locationData, setLocationData] = useState(null);
  const [employee, setEmployee] = useState(null);
  const [vehicles, setVehicles] = useState([]);

  const handleClick = (point, employee) => {
    setEmployee(employee);
    setLocationData(point);
  };

  const [debouncedValue] = useDebounce(filterDataInput, 500);
  const columns = Columns({ handleClick });

  const handleChangeFilterDataInput = async (event) => {
    setFilterDataInput(event.target.value);
  };

  const handleFormData = (value, key) => {
    const newFormData = { ...formDateData };
    newFormData[key] = value;
    setFormDateData(newFormData);
  };
  function paginationChange(_, e_page) {
    setPage(e_page - 1);
  }
  const getAllCardEventDataForExcel = async () => {
    setIsLoading(true);

    const { field, sort } =
      sortModel.length > 0 ? sortModel[0] : { field: 'id', sort: 'desc' };
    const { t0, t1 } = formDateData;
    const params = {
      query: encodeURI(filterDataInput),
      ignoreCase: true,
      size: 9999999,
      sort: `${field},${sort}`,
      t0: formatDateWithTimeZoneForSearch(t0),
      t1: formatDateWithTimeZoneForSearch(t1),
    };

    const result = await services.getCardEventswithSearch(params);
    const data = result?.data?.data;
    setAllCardEventsForExcel(data);
    setIsLoading(false);
    await downloadExcelAllCardEvents(result?.data?.data); //todo: excel fonksiyonu optimize edilecek
  };
  let promises = [];
  let addresses = [];
  let coor = [];
  let lat;
  let lon;
  let address;

  async function getAddress(coordinate) {
    if (coordinate != null) {
      coor = coordinate.split(',');
      lat = coor[0];
      lon = coor[1];
      let coordinateNew = lat + ',' + lon;
      let res = await services.getLocation(coordinateNew);
      let data = res?.data;
      address = data;
    }
  }

  async function downloadExcelAllCardEvents(allCardEventsForExcel) {
    const wb = new ExcelJS.Workbook();
    wb.creator = 'Terra Yazılım';
    wb.created = new Date();
    wb.modified = new Date();
    const ws = wb.addWorksheet();
    ws.columns = [
      { header: textPool['Durum'], key: 'status', width: 15 },
      { header: textPool['Araç Plakası'], key: 'vehicleId', width: 20 },
      { header: textPool['Şoför Adı Soyadı'], key: 'driverId', width: 30 },
      { header: textPool['Kart Numarası'], key: 'cardId', width: 30 },
      { header: textPool['Personel Adı'], key: 'employeId', width: 25 },
      { header: textPool['Koordinat'], key: 'coordinate', width: 35 },
      // { header: 'Adres', key: 'address', width: 35 },
      { header: textPool['Tarih'], key: 'time', width: 20 },
    ];

    allCardEventsForExcel.forEach(async (item, index, arr) => {
      const {
        id,
        status,
        card,
        employee,
        time,
        coordinate,
        identification,
        vehicle,
        driver,
      } = item;
      // await getAddress(coordinate);
      Promise.all(promises).then(() => {
        ws.addRow({
          status: `${
            status === 'SUCCESFULL'
              ? textPool['BAŞARILI']
              : textPool['BAŞARISIZ']
          }`,
          vehicleId: `${vehicle?.id || '-'}`,
          driverId: `${driver?.id || '-'}`,
          cardId: `${card?.id || identification || '-'}`,
          employeId: `${employee?.id || '-'}`,
          coordinate: `${coordinate || '-'}`,
          // address: `${address?.data || '-'}`,
          time: `${new Date(time).toLocaleString('tr')}`,
        });

        if (!arr[index + 1]) {
          saveExcel();
        }
      });
    });

    async function saveExcel() {
      const buf = await wb.xlsx.writeBuffer();
      saveAs(
        new Blob([buf]),
        textPool['Kart Raporu'] + ' ' + `${new Date()}.xlsx`,
      );
    }
  }

  const getAllCardEventDataForDashboard = async () => {
    setIsFetching(true);

    const { field, sort } =
      sortModel.length > 0 ? sortModel[0] : { field: 'id', sort: 'desc' };
    const { t0, t1 } = formDateData;
    const params = {
      query: encodeURI(filterDataInput),
      ignoreCase: true,
      size: 9999999,
      sort: `${field},${sort}`,
      t0: formatDateWithTimeZoneForSearch(t0),
      t1: formatDateWithTimeZoneForSearch(t1),
    };

    const result = await services.getCardEventswithSearch(params);
    const data = result?.data?.data;
    setAllCardEventsForExcel(data);
    setIsFetching(false);
  };

  const getAllTransportationDataForDashboard = async () => {
    setIsLoading(true);
    const { field, sort } =
      sortModel.length > 0 ? sortModel[0] : { field: 'id', sort: 'desc' };
    const { t0, t1 } = formDateData;
    const params = {
      query: encodeURI(filterDataInput),
      ignoreCase: true,
      size: 9999999,
      sort: `${field},${sort}`,
      t0: formatDateWithTimeZoneForSearch(t0),
      t1: formatDateWithTimeZoneForSearch(t1),
    };

    const result = await services.getAllTransportationWithSearch(params);
    const data = result?.data?.data;
    const uniqueVehicle = [];
    data?.forEach((item) => {
      if (!uniqueVehicle.includes(item?.schema?.vehicle?.id)) {
        uniqueVehicle.push(item?.schema?.vehicle?.id);
      }
    });
    setVehicles(uniqueVehicle);
    setIsLoading(false);
  };

  const getAllCardEventsData = async () => {
    setIsLoading(true);
    const { field, sort } =
      sortModel.length > 0 ? sortModel[0] : { field: 'id', sort: 'desc' };
    const { t0, t1 } = formDateData;

    const params = {
      query: encodeURI(filterDataInput),
      ignoreCase: true,
      size: 10,
      page: page,
      sort: `${field},${sort}`,
      t0: formatDateWithTimeZoneForSearch(t0),
      t1: formatDateWithTimeZoneForSearch(t1),
    };
    const result = await services.getCardEventswithSearch(params);
    const data = result?.data?.data;
    const properties = result?.data?.properties;
    setCount(properties?.totalPages);
    setAllCardEvents(data);
    setIsLoading(false);
  };

  const Centerer = () => {
    const map = useMap();
    useEffect(() => {
      if (locationData) {
        const [lat, lon] = locationData.split(',');
        map.flyTo([lat, lon], 14, {
          duration: 0.6,
        });
      }
    }, [locationData, map]);

    return null;
  };

  useEffect(() => {
    getAllCardEventsData();
    getAllCardEventDataForDashboard();
    getAllTransportationDataForDashboard();
  }, [page, debouncedValue, sortModel, formDateData, location]);

  return (
    <FullLayout>
      <div className="flex flex-col justify-center items-center p-2">
        <div className="w-max max-sm:w-full h-full">
          <>
            <div className="bg-white rounded-xl shadow-xl max-sm:w-full w-full h-full p-3 m-3 max-sm:m-0 max-sm:p-1 ">
              <div className="text-left max-sm:text-center max-sm:text-sm w-full p-3 m-3 max-sm:m-0 max-sm:p-3 text-xl flex justify-center items-center">
                <div className="flex justify-center items-center p-3 m-3 max-sm:m-0 text-center shadow-lg rounded-lg">
                  {moment(formDateData.t0).format('Do MMMM YYYY')} <br />
                  {moment(formDateData.t0).format('HH:mm')}
                </div>
                <div className="flex justify-center items-center p-3 m-3 text-center w-1/2 max-sm:w-1/12">
                  <hr className="border-t-[4px] w-full border-black  border-dotted " />
                </div>
                <div className="flex justify-center items-center p-3 m-3 text-center shadow-lg rounded-lg">
                  {moment(formDateData.t1).format('Do MMMM YYYY')} <br />
                  {moment(formDateData.t1).format('HH:mm')}
                </div>
              </div>
              <div className="flex justify-evenly max-sm:flex-wrap items-center p-3 m-3 max-sm:m-0 max-sm:p-3 w-full">
                <div className="flex flex-col max-sm:w-max w-7/12">
                  <div className="flex max-sm:flex-wrap p-2 m-2 gap-2 max-sm:w-full max-sm:m-0">
                    <div className="w-full flex max-sm:flex-wrap flex-col justify-center items-center p-2 m-2 gap-2 max-sm:m-0">
                      <div className=" flex bg-blue-50 rounded-md p-2 w-80 ">
                        <div className="rounded-md shadow-md m-2 w-12  h-12 bg-[#E8E7FD] flex justify-center items-center">
                          <MATERIEL_ICONS.Cast style={{ color: '#9E97F5' }} />
                        </div>
                        <div className="flex flex-col justify-start">
                          <span className="p-1 ">Cihaz Sayısı</span>
                          <span className="p-1 font-bold text-left">
                            {isLoading ? (
                              <CircularProgress
                                style={{ width: '20px', height: '20px' }}
                              />
                            ) : (
                              <Number n={vehicles?.length} />
                            )}
                          </span>
                        </div>
                      </div>

                      <div className="flex bg-cyan-50 rounded-md p-2 w-80 ">
                        <div className="rounded-md shadow-md m-2 w-12 h-12 bg-[#b8f9fc] flex justify-center items-center">
                          <MATERIEL_ICONS.CreditCard
                            style={{ color: '#02cdfa' }}
                          />
                        </div>
                        <div className="flex flex-col justify-start">
                          <span className="p-1 ">Okutulan Kart Sayısı</span>
                          <span className="p-1 font-bold text-left">
                            {isLoading ? (
                              <CircularProgress
                                style={{ width: '20px', height: '20px' }}
                              />
                            ) : (
                              <Number n={allCardEventsForExcel?.length || 0} />
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex flex-col max-sm:flex-wrap justify-center items-center p-2 m-2 gap-2 max-sm:m-0">
                      <div className="flex bg-red-50 rounded-md p-2 w-80 ">
                        <div className="rounded-md shadow-md m-2 w-12 h-12 bg-[#fca9b8] flex justify-center items-center">
                          <MATERIEL_ICONS.CreditCardOff
                            style={{ color: '#f52f52' }}
                          />
                        </div>
                        <div className="flex flex-col justify-start">
                          <span className="p-1 ">Başarısız Okutulan Kart</span>
                          <span className="p-1 font-bold text-left">
                            {isLoading ? (
                              <CircularProgress
                                style={{ width: '20px', height: '20px' }}
                              />
                            ) : (
                              <Number
                                n={
                                  allCardEventsForExcel?.filter(
                                    (item) => item.status !== 'SUCCESSFUL',
                                  ).length || 0
                                }
                              />
                            )}
                          </span>
                        </div>
                      </div>

                      <div className="flex bg-green-50 rounded-md p-2 w-80 ">
                        <div className="rounded-md shadow-md m-2 w-12  h-12 bg-[#bdffc7] flex justify-center items-center">
                          <MATERIEL_ICONS.CreditScore
                            style={{ color: '#08c949' }}
                          />
                        </div>
                        <div className="flex flex-col justify-start">
                          <span className="p-1 ">Başarılı Okutulan Kart</span>
                          <span className="p-1 font-bold text-left">
                            {isLoading ? (
                              <CircularProgress
                                style={{ width: '20px', height: '20px' }}
                              />
                            ) : (
                              <Number
                                n={
                                  allCardEventsForExcel?.filter(
                                    (item) => item.status === 'SUCCESSFUL',
                                  ).length || 0
                                }
                              />
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex max-sm:w-max max-sm:flex-wrap justify-center items-center w-5/12">
                  <div className=" w-[300px] flex justify-center items-center">
                    <div>
                      <TPieChart
                        text="Kart Okutma Başarı Oranı"
                        rate={
                          allCardEventsForExcel?.length > 0
                            ? allCardEventsForExcel?.filter(
                                (item) => item.status === 'SUCCESSFUL',
                              ).length / allCardEventsForExcel?.length
                            : 0
                        }
                        subtitle={
                          allCardEventsForExcel?.length > 0
                            ? `${(
                                (allCardEventsForExcel?.filter(
                                  (item) => item.status === 'SUCCESSFUL',
                                ).length /
                                  allCardEventsForExcel?.length) *
                                100
                              ).toFixed(2)}%`
                            : '0%'
                        }
                        bgColor={['green', 'rgba(0,128,0,0.3)']}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex  max-sm:w-full  max-sm:flex-col justify-center items-center w-full h-full gap-5 mb-3 p-3 m-3 max-sm:m-0">
              <div className="">
                <span className="text-lg sm:text-2xl max-sm:text-center p-2 m-2">
                  {textPool['Kart Raporları']}
                </span>
              </div>
              <div className="py-3 px-2 mx-3 my-2 max-sm:m-0 flex justify-between max-sm:justify-center gap-3 items-center max-xl:w-full">
                <div className="flex flex-row max-sm:flex-col  w-full gap-4">
                  <TextField
                    sx={{ [theme.breakpoints.down('md')]: { width: '100%' } }}
                    size="small"
                    placeholder={textPool['Arama']}
                    onChange={handleChangeFilterDataInput}
                    value={filterDataInput}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MATERIEL_ICONS.Search />
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: '8px',
                      },
                    }}
                  />
                  <DateTimePicker
                    sx={{ [theme.breakpoints.down('md')]: { width: '100%' } }}
                    label={textPool['Başlangıç Tarihi']}
                    ampm={false}
                    inputFormat="dd/MM/yyyy hh:mm"
                    value={formDateData.t0}
                    onChange={(e) => {
                      handleFormData(e, 't0');
                    }}
                    slotProps={{ textField: { size: 'small' } }}
                  />

                  <DateTimePicker
                    sx={{ [theme.breakpoints.down('md')]: { width: '100%' } }}
                    label={textPool['Bitiş Tarihi']}
                    ampm={false}
                    inputFormat="dd/MM/yyyy hh:mm"
                    value={formDateData.t1}
                    onChange={(e) => handleFormData(e, 't1')}
                    slotProps={{ textField: { size: 'small' } }}
                    minDate={formDateData.endDate}
                    minTime={formDateData.endDate}
                    maxDate={Date.now()}
                    maxTime={Date.now()}
                    disableIgnoringDatePartForTimeValidation
                  />
                  <Button
                    startIcon={<MATERIEL_ICONS.FileDownload />}
                    sx={{ [theme.breakpoints.down('md')]: { width: '100%' } }}
                    disabled={isLoading}
                    className="mr-1"
                    variant="contained"
                    onClick={() => {
                      getAllCardEventDataForExcel();
                    }}
                  >
                    {textPool['Dışa Aktar']}{' '}
                    {isLoading && (
                      <div role="status">
                        <svg
                          aria-hidden="true"
                          className="w-4 h-4 mx-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                        <span className="sr-only">
                          {textPool['Loading...']}
                        </span>
                      </div>
                    )}
                  </Button>
                </div>
              </div>
            </div>

            {isFetching ? (
              <div className="flex justify-center items-center w-full">
                <CircularProgress />
              </div>
            ) : (
              <>
                <div className="w-full bg-white rounded-xl shadow-xl p-3 m-3 max-sm:m-0 max-sm:my-2">
                  <DataGrid
                    rows={allCardEvents}
                    columns={columns}
                    sortModel={sortModel}
                    setSortModel={setSortModel}
                  />
                  <div className="flex justify-center items-center p-3 m-3">
                    <Pagination
                      page={page + 1}
                      onChange={paginationChange}
                      count={count}
                      color="primary"
                      size="small"
                    />
                  </div>
                </div>
                <div
                  id="map"
                  className="bg-white rounded-xl shadow-xl  m-3 my-6 w-full max-sm:mx-0 max-sm:my-2"
                >
                  <MapContainer
                    attributionControl={false}
                    style={{
                      width: '100%',
                      height: '700px',
                    }}
                    className="rounded-xl"
                    center={[37.87244919634651, 32.49206387333341]}
                    zoom={13}
                    scrollWheelZoom={true}
                  >
                    <TileLayer
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
                      url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                    />
                    {locationData && (
                      <Marker
                        icon={L.icon({
                          iconUrl: DraggedIcon,
                          iconSize: [30, 30],
                          iconAnchor: [15, 30],
                        })}
                        position={[
                          locationData.split(',')[0],
                          locationData.split(',')[1],
                        ]}
                      >
                        <Popup>
                          {employee?.id} {employee?.user?.firstname}{' '}
                          {employee?.user?.lastname}
                        </Popup>
                      </Marker>
                    )}
                    <Centerer />
                  </MapContainer>
                </div>
              </>
            )}
          </>
        </div>
      </div>
    </FullLayout>
  );
}

export default CardEvents;
